import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import { ref, onMounted } from "vue"
  import { useRoute } from "vue-router"
  import CardTemplate from "@/components/template/CardTemplate.vue"
  import { useResourcesStore } from "@/store/resources"
  import { useCompanyStore } from "@/store/company"
  import { IonToolbar, IonHeader, IonButtons, IonBackButton, IonButton, IonSelect, IonSelectOption, loadingController, IonFooter, IonList, IonItem, IonLabel } from "@ionic/vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPage',
  setup(__props) {

  const listOfCompanySize = ["1-150", "151-500", "501-1,000", "1,001-2,000", "2,001-5,000", "5,001-10,000", "10,001-20,000", "20,001-50,000", "50,001-100,000", "100,000+"]
  const listOfCompanyType = ["startup", "smb", "large corporate", "public sector", "medium-sized", "non-profit"]
  const listOfWorkSetup = ["Remote", "Office", "Hybrid"]
  const resourcesStore = useResourcesStore()
  const companyStore = useCompanyStore()
  const route = useRoute()

  const onClear = () => {
    companyStore.filters.sort = window.location.href.includes("/job-board") ? "alphabetical" : "recent"
    companyStore.filters.companysize = ""
    companyStore.filters.companytype = ""
    companyStore.filters.worksetup = ""
    companyStore.filters.amenities = ""
    companyStore.filters.benefits = ""
    companyStore.filters.techstack = ""
    companyStore.filters.ebp = ""
  }

  onMounted(async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await resourcesStore.retrieveIndustries()
    await resourcesStore.retrieveBAT("technologies")
    await resourcesStore.retrieveBAT("benefits")
    await resourcesStore.retrieveBAT("amenities")
    await resourcesStore.retrieveEBPList()
    loading.dismiss()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createVNode(CardTemplate, null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonList), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Sort")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: _unref(companyStore).filters.sort,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(companyStore).filters.sort) = $event)),
                      placeholder: "Sort"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSelectOption), { value: "recent" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Newly joined")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelectOption), { value: "alphabetical" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Name A-Z")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Company Size")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: _unref(companyStore).filters.companysize,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(companyStore).filters.companysize) = $event)),
                      multiple: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listOfCompanySize, (size) => {
                          return _createVNode(_unref(IonSelectOption), {
                            key: size,
                            value: size
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(size), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Company Type")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: _unref(companyStore).filters.companytype,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(companyStore).filters.companytype) = $event)),
                      multiple: true,
                      class: "capitalize"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listOfCompanyType, (cType) => {
                          return _createVNode(_unref(IonSelectOption), {
                            key: cType,
                            value: cType,
                            class: "capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(cType), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Work Setup")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: _unref(companyStore).filters.worksetup,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(companyStore).filters.worksetup) = $event)),
                      multiple: true,
                      class: "capitalize"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listOfWorkSetup, (worksetup) => {
                          return _createVNode(_unref(IonSelectOption), {
                            key: worksetup,
                            value: worksetup,
                            class: "capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(worksetup), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Amenities")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: _unref(companyStore).filters.amenities,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(companyStore).filters.amenities) = $event)),
                      multiple: true,
                      class: "capitalize"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesStore).selection.amenities, (amenity) => {
                          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                            key: amenity.id,
                            value: amenity.name,
                            class: "capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(amenity.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Benefits")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: _unref(companyStore).filters.benefits,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(companyStore).filters.benefits) = $event)),
                      multiple: true,
                      class: "capitalize"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesStore).selection.benefits, (benefit) => {
                          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                            key: benefit.id,
                            value: benefit.name,
                            class: "capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(benefit.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_unref(route).path === '/job-board')
                  ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Technologies")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          modelValue: _unref(companyStore).filters.techstack,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(companyStore).filters.techstack) = $event)),
                          multiple: true,
                          class: "capitalize"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesStore).selection.technologies, (benefit) => {
                              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                key: benefit.id,
                                value: benefit.id,
                                class: "capitalize"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(benefit.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_unref(IonItem), { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Employer Brand Personality")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          modelValue: _unref(companyStore).filters.ebp,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(companyStore).filters.ebp) = $event)),
                          multiple: true,
                          class: "capitalize"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesStore).ebp, (ebp) => {
                              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                key: ebp.id,
                                value: ebp.id,
                                class: "capitalize"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(ebp.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), { class: "ion-no-border" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "p-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButton), {
              expand: "block",
              color: "white",
              class: "text-primary-violet font-bold rounded-base shadow-base",
              onClick: onClear
            }, {
              default: _withCtx(() => [
                _createTextVNode("Clear")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})